<template>
    <div class="wrapper">
        <div name="info-modal" class="modal">
        
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <span class="title">병원목록 조회 안내</span>
                <span class="label1">조회 가능한 범위</span>
                <span class="modal-text">병원 목록은 개별 병원 홈페이지에서 회원가입을 완료한 병원만 확인할 수 있어요.</span>
                <span class="label2">조회 불가능한 범위</span>
                <span class="modal-text">솔닥 앱에서 예약한 기록은 앱 내 진료내역에서 확인할 수 있어요.<br>다른 플랫폼에서 예약한 기록은 이곳에서 확인되지 않아요.</span>
   
                <div class="row" style="margin-top: 36px;">
                    <div class="button1" @click="onClick">앱에서 보기</div>
                    <div class="button2" @click="onClose">닫기</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// error modal 

export default {
    name: 'infoModal',
    mounted: function()
    {
        const el = document.querySelector('.contents');
        const height = el.offsetHeight;

        const element = document.querySelector('.touch');       
        element.style.height = `calc(100vh - ${height}px)`;

        console.log('높이:', height);
    },  
    methods: {
        onClose : function()
        {
            this.$emit('onClose');
        },
        onClick: function()
        {
            this.$emit('onClick')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: 1;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 11;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        width: calc(100%);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }

    .message {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 20px;
    }
    .button1 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button2 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .label1 {
        border-radius: 3px;
        background: var(--semantic-light-blue, #E5F0FC);
        box-sizing: border-box;
        padding: 5px 8px;
        color: var(--semantic-blue, #008DEF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 32px;
    }
    .modal-text {
        color: var(--gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        margin-top: 8px;
    }
    .label2 {
        border-radius: 3px;
        background: var(--semantic-light-red, #FFF3F3);
        box-sizing: border-box;
        padding: 5px 8px;
        color: var(--semantic-red, #F00);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/my/InfoModal.vue